import React from 'react';
import LocalSeoPage from './LocalSeoPage';

const DepannageSaintJulien: React.FC = () => (
  <LocalSeoPage
    city="Saint-Julien-en-Genevois"
    cityShort="Saint-Julien"
    slug="depannage-informatique-saint-julien-en-genevois"
    metaTitle="Dépannage informatique Saint-Julien-en-Genevois | SOS IT"
    metaDescription="Technicien informatique à Saint-Julien-en-Genevois. Réparation PC, virus, WiFi. Intervention à domicile. Devis gratuit."
    intro="Vous êtes à Saint-Julien-en-Genevois et votre ordinateur ne fonctionne plus correctement ? Notre technicien intervient rapidement, à votre domicile. Virus, PC lent, connexion WiFi en panne, Windows bloqué — nous trouvons la solution sans jargon technique."
    postalCode="74160"
    cityFaqs={[
      { question: "Quel est le délai d'intervention à domicile à Saint-Julien-en-Genevois ?", answer: "Saint-Julien-en-Genevois est à environ 10 minutes de Viry, ce qui facilite les déplacements. Le créneau dépend de notre planning : contactez-nous (réponse en moins de 2h, 7j/7, intervention souvent le jour même) et nous vous proposons une date." },
      { question: "Intervenez-vous directement chez moi à Saint-Julien ?", answer: "Oui, nous nous déplaçons chez vous à Saint-Julien-en-Genevois, déplacement inclus. Contactez-nous pour convenir d'un créneau." },
    ]}
    travelTime="≈ 10 min de Viry"
    phoneRepairLink={{ label: "Réparation téléphone à Saint-Julien-en-Genevois", href: "/reparation-telephone-saint-julien-en-genevois" }}
    nearbyTowns={[
      { name: 'Viry', link: '/depannage-informatique-viry' },
      { name: 'Valleiry', link: '/depannage-informatique-valleiry' },
      { name: 'Annemasse', link: '/depannage-informatique-annemasse' },
      { name: 'Pays de Gex', link: '/depannage-informatique-pays-de-gex' },
      { name: 'Archamps', link: '/depannage-informatique-archamps' },
      { name: 'Collonges-sous-Salève', link: '/depannage-informatique-collonges-sous-saleve' },
      { name: 'Neydens' },
      { name: 'Présilly' },
      { name: 'Beaumont' },
    ]}
    internalLinks={[
      { label: 'Création de site internet à Saint-Julien-en-Genevois', href: '/creation-site-internet-saint-julien-en-genevois' },
      { label: 'Dépannage informatique à Viry', href: '/depannage-informatique-viry' },
      { label: 'Dépannage informatique à Valleiry', href: '/depannage-informatique-valleiry' },
      { label: 'Dépannage informatique à Annemasse', href: '/depannage-informatique-annemasse' },
      { label: 'Dépannage informatique dans le Pays de Gex', href: '/depannage-informatique-pays-de-gex' },
      { label: 'Dépannage informatique à Archamps', href: '/depannage-informatique-archamps' },
      { label: 'Dépannage informatique à Collonges-sous-Salève', href: '/depannage-informatique-collonges-sous-saleve' },
      { label: 'Dépannage informatique autour de Genève', href: '/depannage-informatique-geneve' },
    ]}
  />
);

export default DepannageSaintJulien;
